export enum TYPES_KEY {
  TYPE_1 = "決算短信",
  TYPE_2 = "第3四半期決算短信",
  TYPE_3 = "第2四半期決算短信",
  TYPE_4 = "第1四半期決算短信",
  TYPE_5 = "有価証券報告書",
  TYPE_6 = "第3四半期報告書",
  TYPE_7 = "第2四半期報告書",
  TYPE_8 = "第1四半期報告書",
}

export const TYPES = {
  [TYPES_KEY.TYPE_1]: "決算短信",
  [TYPES_KEY.TYPE_2]: "第3四半期決算短信",
  [TYPES_KEY.TYPE_3]: "第2四半期決算短信",
  [TYPES_KEY.TYPE_4]: "第1四半期決算短信",
  [TYPES_KEY.TYPE_5]: "有価証券報告書",
  [TYPES_KEY.TYPE_6]: "第3四半期報告書",
  [TYPES_KEY.TYPE_7]: "第2四半期報告書",
  [TYPES_KEY.TYPE_8]: "第1四半期報告書",
};
